import React from 'react';

import { useExportAsnLazyQuery } from 'generated/graphql';
import * as types from './types';
import { protectedFileUtil } from 'iron-forge-react-modules';
import { DateTime } from 'luxon';



export function useExportAsnMutation(storeId: string) {
  const [fnQuery, tuple] = useExportAsnLazyQuery({fetchPolicy: 'no-cache'});



  const fnWrappedQuery = React.useCallback(
    async (formState: types.IFormState) => {
      await fnQuery({
        variables: {
          input: {
            storeId,
            after: DateTime.fromJSDate(formState.after).toISO() as string,
            before: DateTime.fromJSDate(formState.before).toISO() as string
          }
        }
      });
    },
    [fnQuery, storeId]
  );



  React.useEffect(
    ()=> {
      if (tuple.called && !tuple.loading && tuple.data) {
        if (tuple.data.exportAsn) {
          protectedFileUtil.forceDownloadEncodedFile(tuple.data.exportAsn);
        } else {
          alert("No rows found for ASN.");
        }
      }
    },
    [tuple]
  );



  return [
    fnWrappedQuery,
    tuple
  ] as const;
}
